import constants from "../../../core/constants";
import find from "lodash/fp/find";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, type, types) {
    "ngInject";

    this.type = type;
    this.types = types;
    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    this.invoiceItemsList = this.types;
  }

  close() {
    this.$mdDialog.cancel();
  }

  handleChangeType() {
    const getItem = (item) => item.name === this.invoiceItemType;
    this.item = find(getItem)(this.invoiceItemsList);

    this.extraField = {};
    this.extraFieldsTypes = this.item.extraFields;
  }

  confirm() {
    if (this.amount && this.note && this.invoiceItemType) {
      const amount = this.amount * constants.currencyBy;
      const note = this.note;
      const type = this.invoiceItemType;
      let extraField = {};
      Object.entries(this.extraField).forEach(([key, value]) => {
        extraField = {
          ...extraField,
          [key]: isNil(value._id) ? value : value._id,
        };
      });

      this.$mdDialog.hide({
        amount,
        note,
        type,
        ...extraField,
      });
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoice/manualInvoiceDialog/manualInvoiceDialog.controller.js